<template>
  <b-row>
    <b-col sm="12" lg="12">
      <b-card class="lineClass">
        <div slot="header">
          <h4 style="display: inline;" id="traffic" class="card-title mb-0">Region Overview</h4>
          <div class="card-header-actions">
            <b-button
              style="display: inline;padding-top: 1.5px !important;"
              @click="toggleFullScreenLine"
              class="float-right"
              variant="transparent p-0"
              right
            >
              <i class="icon-frame" style="color: #20a8d8;"></i>
            </b-button>
          </div>
        </div>
        <br />
        <!-- <div style="height: 400px; padding-top: 150px" v-if="loadingState" class="loading">
          <b-row>
            <b-col lg="12">
              <div class="sk-double-bounce">
                <div class="sk-child sk-double-bounce1"></div>
                <div class="sk-child sk-double-bounce2"></div>
              </div>
            </b-col>
          </b-row>
        </div>-->
        <GChart
          v-if="!loadingState"
          :settings="{ packages: [ 'geochart'], mapsApiKey: mapApiKey}"
          type="GeoChart"
          :data="chartData1"
          :options="chartOptions"
          :events="chartEvents"
          style
          ref="gChart"
          class="themap"
        />
        <div slot="footer"></div>
      </b-card>
    </b-col>
  </b-row>
</template>
<style scoped>
.vdp-datepicker__calendar {
  position: absolute !important;
  z-index: 100;
  background: #3a4149 !important;
  width: 300px;
  border: 1px solid #ccc;
}
.power {
  background-color: #f86c6b !important;
}
.form-control:disabled,
.form-control[readonly] {
  background-color: #515b65 !important;
  opacity: 1 !important;
}
</style>
<script>
import { GChart } from "vue-google-charts";
import Datepicker from "vuejs-datepicker";
import router from "../../router";
export default {
  props: ["state", "date_from", "date_to", "locations"],
  name: "App",
  components: {
    GChart,
    router,
    Datepicker
  },
  data() {
    return {
      stateModal: false,
      mapReady: false,
      stateDateFrom: "",
      stateDateTo: "",
      loadingState: true,
      chartData: [],
      chartData1: [],
      mapApiKey: process.env.VUE_APP_GOOGLE_MAPS_API,
      //
      //   ["City", "Population"],
      // ["Indianapolis", 1000],
      //   ["New York", 1170],
      //   ["Las Vegas", 660],
      //   ["Chicago", 1030]
      chartOptions: {
        showZoomOut: true,
        tooltip: { isHtml: true },

        backgroundColor: "#3a4149",
        // datalessRegionColor: '#afbbbf',
        // defaultColor: '#f5f5f5',
        legend: {
          textStyle: { color: "black", fontSize: 16, font: "Segoe UI" }
        },
        region: "USA",
        sizeAxis: {
          // minValue: 1, //code to set min and max values in geo chart
          // maxValue: 4,
          minSize: 8, //code to set min and max marker size
          maxSize: 8
        },
        resolution: "provinces",
        magnifyingGlass: { enable: true, zoomFactor: 1.5 },
        displayMode: "markers",
        enableRegionInteractivity: true,
        keepAspectRatio: false,

        colorAxis: { colors: ["#28B463", "#6C3483"] }
      },
      chartEvents: {
        select: () => {
          const selection = this.$refs.gChart.chartObject;
          var selectedItem = selection.getSelection()[0];
          var topping = this.chartData[selectedItem.row + 1];
          console.log("1", topping[2].split("#"));
          var splitting = topping[2].split("#");
          var id = splitting[1];
          var city = topping[0];
          var lat = splitting[2];
          var lng = splitting[3];
          router.push(
            "/base/city/?loc=" +
              id +
              "&city=" +
              city +
              "&lat=" +
              lat +
              "&lng=" +
              lng
          );
        }
      }
    };
  },
  methods: {
    stateModalEvent() {
      if (this.fullscreenState) {
        this.toggleFullScreenState();
        this.stateModal = 1;
      } else {
        this.stateModal = 1;
      }
    },
    fetchCityReport() {
      this.loadingState = true;
      let params = {};
      params = {
        state: this.state,
        date_from: this.date_from,
        date_to: this.date_to
      };
      this.$http
        .get("api/viavi/maps/mapByState.php", { params })
        .then(
          res => {
            this.loadingState = false;
            this.chartData = res.data.records;
            var myFix = { type: "string", role: "tooltip", p: { html: true } };

            this.chartData[0][2] = myFix;

            var i;
            for (i = 1; i < this.chartData.length; i++) {
              var prvi = this.chartData[i][0].split("#");
              this.chartData[i][0] = prvi[0];
              this.chartData[i][2] =
                "<div style='width:130px'><span>Quantitiy: " +
                this.chartData[i][1] +
                "</span><br>" +
                "<span>$" +
                this.chartData[i][2].toFixed(2) +
                "</span><br></div><div style='display:none'>#" +
                prvi[1] +
                "#" +
                prvi[2] +
                "#" +
                prvi[3] +
                "#</div>";
              console.log("markan");
              console.log(this.chartData);
              console.log(this.chartData[i][2]);
            }

            // this.data1 = this.data
            //this.optionsMap.series[0].data = res.data.records;
            // console.log(this.data)
            this.loadingState = false;
            this.chartData1 = this.chartData;
          },
          err => {
            console.log(err);
            this.loadingState = false;
          }
        );
    },
    toggleFullScreenLine() {
      this.$fullscreen.toggle(this.$el.querySelector(".lineClass"), {
        wrap: false,
        callback: this.fullscreenChangeLine
      });
    }
  },
  mounted() {
    this.chartOptions.region = "US-" + this.state;
    console.log(this.chartOptions.region);
    this.fetchCityReport();
  }
};
</script>
